// ----------------------------------------------------------------------

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    smd: 650,
    md: 900,
    lg: 1200,
    xl: 1536
  }
};

export default breakpoints;
